<template>
	<div style="margin: 0 20px;background-color: white;padding: 20px;">
		<div style="margin-bottom: 10px; padding: 20px 0; background-color: #f1f1f1;text-align: center;">新建商品</div>
		<el-form label-position="top" label-width="80px" :model="formData">
			<el-form-item label="商品分类">
				<el-select v-model="formData.categoryId" placeholder="请选择">
				    <el-option
				      v-for="item in options"
				      :key="item.category_id"
				      :label="item.category_name"
				      :value="item.category_id">
				    </el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品标题">
				<el-input v-model="formData.productTitle"></el-input>
			</el-form-item>
			<el-form-item label="商品介绍">
				<el-input v-model="formData.productIntro"></el-input>
			</el-form-item>
			<el-form-item label="商品图片">
				<el-upload
				  class="avatar-uploader"
				  :data="uploadData"
				  action="/api/minio/upload"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="formData.productPicture" :src="formData.productPicture" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			<el-form-item label="商品原价">
				<el-input @input="limitInput($event,'productPrice')" v-model.trim="formData.productPrice"></el-input>
			</el-form-item>
			<el-form-item label="售卖价">
				<el-input @input="limitInput($event,'productSellingPrice')" v-model.trim="formData.productSellingPrice"></el-input>
			</el-form-item>
			<el-form-item label="商品库存">
				<el-input type="number" v-model="formData.productNum"></el-input>
			</el-form-item>
			<el-form-item>
			    <el-button type="primary" @click="onSubmit">立即创建</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				uploadData:{
					bucketName:'webgoods'
				},
				options: [],	//分类数据	
				formData:{
					productName:"",
					categoryId:"",
					productTitle:"",
					productIntro:"",
					productPicture:"",
					productPrice:"",
					productSellingPrice:"",
					productNum:"",
				}
			}
		},
		created(){
			this.getCategory()
		},
		methods:{
			getCategory(){
				this.$axios.post("/api/product/getCategory", {}).then(res => {
				    if (res.data.code === "200" || res.data.code === 200) {
						this.options = res.data.data.category
				    } else {
						// 提示失败信息
						this.notifyError(res.data.msg);
				    }
				}).catch(err => {
				    return Promise.reject(err);
				});
			},
			limitInput(value, name) {
				this.formData[name] =
					("" + value) // 第一步：转成字符串
					.replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
					.replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
					.replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
					.match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
			},
			beforeAvatarUpload(file){
				const houzhui = ['image/jpeg','image/png','image/bmp','image/webp','image/jpg']
				const isJPG = houzhui.includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				if (!isJPG) {
				  this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
				  this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			handleAvatarSuccess(res, file){
				this.formData.productPicture = res.data.url;
			},
			onSubmit(){
				if(!this.formData.categoryId){
					this.notifyError("请选择商品分类");
					return
				}else if(!this.formData.productTitle){
					this.notifyError("请填写商品标题");
					return
				}else if(!this.formData.productIntro){
					this.notifyError("请填写商品简介");
					return
				}else if(!this.formData.productPicture){
					this.notifyError("请上传商品图片");
					return
				}else if(!this.formData.productSellingPrice){
					this.notifyError("请填写商品售卖价格");
					return
				}else if(!this.formData.productNum){
					this.notifyError("请填写商品库存");
					return
				}
				this.formData.productName = this.formData.productTitle
				this.$axios.post("/api/product/backend/addProduct", this.formData).then(res => {
				    if (res.data.code === "200" || res.data.code === 200) {
						// 提示成功信息
						this.notifySucceed("创建商品成功");
						this.$router.back()
				    } else {
						// 提示失败信息
						this.notifyError(res.data.msg);
				    }
				}).catch(err => {
				    return Promise.reject(err);
				});
			}
		}
	}
</script>

<style>
	.avatar-uploader  {
	    border: 1px dashed #a1a1a1;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		text-align: center;
		width: 150px;
		height: 150px;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #a1a1a1;
	    width: 150px;
	    height: 150px;
	    line-height: 150px;
	    text-align: center;
	  }
	  .avatar {
	    width: 150px;
	    height: 150px;
	    display: block;
	  }
</style>